var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 313.70004,
    height: 64.699997,
    viewBox: "0 0 8333 1718.4821",
    id: "svg52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2971D",
    fillRule: "nonzero",
    d: "m 1657,892 c 0,485 -347,826 -829,826 C 348,1718 0,1377 0,892 0,439 397,121 828,121 c 432,0 829,318 829,771 z m -1251,2 c 0,258 190,447 422,447 233,0 424,-189 424,-447 0,-207 -191,-396 -424,-396 -232,0 -422,189 -422,396 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2971D",
    points: "2170,1669 1808,1669 1808,20 2170,20 ",
    id: "polygon9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2971D",
    d: "M 2786,1669 H 2424 V 948 H 2297 V 650 h 127 V 520 c 0,-141 4,-244 104,-357 89,-105 218,-163 355,-163 56,0 105,10 155,36 v 312 c -42,-18 -79,-34 -127,-34 -94,0 -125,55 -125,171 v 165 h 252 V 948 H 2786 Z M 3533,258 c 0,111 -92,203 -203,203 -111,0 -203,-92 -203,-203 0,-111 92,-202 203,-202 111,0 203,91 203,202 z m -22,1411 H 3149 V 650 h 362 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2971D",
    d: "m 4072,781 h 4 c 83,-123 185,-165 326,-165 274,0 383,173 383,423 v 630 h -361 v -497 c 0,-97 15,-268 -163,-268 -147,0 -189,109 -189,236 v 529 H 3710 V 650 h 362 z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "m 6061,673 c -80,-107 -209,-164 -342,-164 -238,0 -399,182 -399,415 0,236 162,407 405,407 127,0 254,-61 336,-159 v 467 c -129,40 -223,70 -344,70 -209,0 -407,-80 -562,-221 -165,-149 -241,-344 -241,-566 0,-205 78,-402 221,-549 147,-151 360,-242 570,-242 126,0 241,28 356,76 z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "m 7368,1669 h -362 v -113 h -3 c -64,101 -189,147 -309,147 -302,0 -514,-253 -514,-545 0,-292 209,-542 511,-542 117,0 240,44 315,133 v -99 h 362 z m -814,-509 c 0,129 85,229 232,229 147,0 232,-100 232,-229 0,-125 -85,-230 -232,-230 -147,0 -232,105 -232,230 z",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "m 7931,816 h 3 c 70,-125 189,-180 331,-180 h 68 v 347 c -49,-27 -97,-33 -152,-33 -201,0 -250,133 -250,308 v 411 H 7569 V 650 h 362 z",
    id: "path19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd1a619cdb6fa7b7ecdfba0b82fa83cf.svg";
export { ForwardRef as ReactComponent };